module.exports = __webpack_public_path__ + "img/08.ad316bae.jpg";